import React, { useEffect, useState } from 'react';
import StowageRotationTreeComponent from './StowageRotationTree';
import { RotationContainerWrapper, RotationHeader } from 'src/pages/stowage/StowagePage.styles';
import VoyageSelectionPanel from '../common/voyageSelectionPanel/VoyageSelectionPanel';
import { useStowageStore } from 'src/context/StowageContext';
import { VoyageOption } from 'src/types/ViewModel/VoyageOption';
import useStowageQueryParamsUtils from 'src/utils/stowage/useStowageQueryParamsUtils';
import { useVesselStore } from 'src/context/VesselContext';
import { generateUnifiedVoyageOptionsList } from 'src/utils/voyageSelectionUtils';
import { useRotationStore } from 'src/context/RotationContext';

const RotationViewContainer: React.FC = () => {
    const [voyageOptionsList, setVoyageOptionsList] = useState<VoyageOption[]>([]);
    const { activeStowagePlan } = useStowageStore();
    const { clearQueryParamsStowagePortCall } = useStowageQueryParamsUtils();
    const { vessel } = useVesselStore();
    const { updatedRotation, currentPortCall } = useRotationStore();

    useEffect(() => {
        if (!activeStowagePlan) return;

        const voyageOptions = generateUnifiedVoyageOptionsList(
            true, // Always use stowage integration logic for StowagePage
            null, // Don't pass updatedRotation - Stowage should only use stowagePlan.rotation
            currentPortCall?.voyageNumber1 ?? '', // Current voyage for status determination
            activeStowagePlan,
            vessel,
            true // isStowageModule = true: Only use stowagePlan, don't merge with updatedRotation
        );

        setVoyageOptionsList(voyageOptions);
    }, [activeStowagePlan, vessel, updatedRotation, currentPortCall]);

    return (
        <RotationContainerWrapper>
            <RotationHeader>
                <VoyageSelectionPanel voyageOptionsList={voyageOptionsList} onClearFiltersCallback={clearQueryParamsStowagePortCall} />
            </RotationHeader>
            <StowageRotationTreeComponent />
        </RotationContainerWrapper>
    );
};

export default RotationViewContainer;
